import { render, staticRenderFns } from "./PropertyDetails.vue?vue&type=template&id=5000a0f2&scoped=true"
import script from "./PropertyDetails.vue?vue&type=script&lang=js"
export * from "./PropertyDetails.vue?vue&type=script&lang=js"
import style0 from "./PropertyDetails.vue?vue&type=style&index=0&id=5000a0f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5000a0f2",
  null
  
)

export default component.exports